"use client";

import { Suspense } from "react";

import { useTranslation } from "react-i18next";

import type { OrganizationRanking } from "@/entities/organization/api/organizations";
import { OrganizationRankingsView } from "@/entities/organization/ui/organization-rankings-view";
import { PublicRankingList } from "@/entities/organization/ui/public-ranking-list";
import type { PaginatedResponse } from "@/shared/api/common";

export function RatingsSection({ initialData }: { initialData?: PaginatedResponse<OrganizationRanking> }) {
  const { t } = useTranslation();

  return (
    <section id="ratings" className="scroll-mt-24 bg-slate-50 px-4 py-20 sm:px-6">
      <div className="mx-auto max-w-7xl">
        <h2 className="text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">
          {t("organizations.ratings.title")}
        </h2>
        <p className="mt-4 text-sm text-slate-600">{t("organizations.ratings.description")}</p>
        <div className="mt-8 h-[800px] min-h-0">
          <Suspense
            fallback={
              <div className="h-full overflow-y-auto">
                <PublicRankingList rows={initialData?.data ?? []} />
              </div>
            }
          >
            <OrganizationRankingsView variant="public" initialData={initialData} />
          </Suspense>
        </div>
      </div>
    </section>
  );
}
